module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/video-c-2-9e465a84834dfd461f14604f9f959452.jpg";